import { useEffect, useState } from "react";
import moment from "moment";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx/xlsx.mjs';

// Components
import NavDashboard from "../../components/NavDashboard";
import { covertTimeZone, numberFormat, NewCovertTimeZone } from "../../helper";

// Apollo Client
import { GET_REPORT_INCOME_COST_V2, GET_REPORT_DIARY_COST_PROFIT } from "../../apollo/dashboard/query";

import { useLazyQuery } from "@apollo/client";

// React Bootstrap
import { Card, Button, Row, Col, Table } from "react-bootstrap";
import AnimationLoading from "../../components/Animationloading";
import _ from "lodash";
import CurrentDateComponents from "../../components/CurrentDateComponents";
import { LINEAR_GRADIENT_BG, APP_COLOR } from "../../const";
import { MdAttachMoney } from "react-icons/md";

export default function ReportIncomeAndCost() {
  // States
  const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
  const [reportDatas, setReportDatas] = useState({
    totalCost: {}, totalSale: {}
  });
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [cdFillter, setCdFillter] = useState({
    createdAt_gte: "",
    createdAt_lt: "",
  });
  const [activeButton, setActiveButton] = useState("thisMonth");
  const [dailyReportDatas, setDailyReportDatas] = useState([]);

  // GraphQL query
  const [getReportIncome, { data: dataReportIncome, loading: loadingReport }] = useLazyQuery(GET_REPORT_INCOME_COST_V2, {
    fetchPolicy: "cache-and-network",
  });

  const [getReportDaily, { data: dataReportDaily }] = useLazyQuery(GET_REPORT_DIARY_COST_PROFIT, {
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    if (dataReportDaily) {
      console.log("dataReportDaily: ", dataReportDaily?.ReportDailyCostProfit?.datas);
      const _datas = dataReportDaily?.ReportDailyCostProfit?.datas || [];
      const sortedDatas = [..._datas].sort((a, b) => new Date(a.date) - new Date(b.date));
      setDailyReportDatas(sortedDatas);
    }
  }, [dataReportDaily]);

  // useEffect to handle data updates
  useEffect(() => {
    if (dataReportIncome) {
      const _newReportDatas = JSON.parse(dataReportIncome?.ReportCostProfit?.datas);
      setReportDatas({
        totalCost: _newReportDatas?.cost,
        totalProfit: _newReportDatas?.profit,
        totalSale: _newReportDatas?.sale,
        totalDiscount: _newReportDatas?.totalDiscount,
      });
    }
  }, [dataReportIncome]);



  useEffect(() => {
    if (shopId && cdFillter.createdAt_gte && cdFillter.createdAt_lt) fetchDataReport();
  }, [shopId, cdFillter]);

  const fetchDataReport = async () => {
    try {
      if (loadingReport) return;

      let _where = {
        shop: shopId,
      };
      if (cdFillter.createdAt_gte !== "" || cdFillter.createdAt_lt !== "") {
        _where = {
          ..._where,
          createdAt_gte: NewCovertTimeZone(cdFillter.createdAt_gte),
          createdAt_lt: NewCovertTimeZone(cdFillter.createdAt_lt),
        };
      }

      await getReportIncome({
        variables: {
          where: _where,
        },
      });

      await getReportDaily({
        variables: {
          where: _where,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const calculatorProfit = (salePrice, costPrice) => {
    return  parseInt(salePrice || 0) - parseInt(costPrice || 0); // Correct calculation: salePrice - costPrice
  };

  const handleDownloadExcel = () => {
    if (!dailyReportDatas || dailyReportDatas.length === 0) {
      alert("ບໍ່ມີຂໍ້ມູນສຳລັບການ Export ກະລຸນາເລືອກວັນທີ (No data to export, please select date)");
      return;
    }

    // Header Row 1
    const headerRow1 = [
      "ວັນທີ",
      "ເງິນກີບ (LAK)", "", "",
      "ເງິນບາດ (THB)", "", "",
      "ເງິນໂດລາ (USD)", "", ""
    ];

    // Header Row 2
    const headerRow2 = [
      "",
      "ຍອດຂາຍ", "ຕົ້ນທຶນ", "ກຳໄລ",
      "ຍອດຂາຍ", "ຕົ້ນທຶນ", "ກຳໄລ",
      "ຍອດຂາຍ", "ຕົ້ນທຶນ", "ກຳໄລ"
    ];

    try {
      const body = dailyReportDatas.map(item => {
         const profitKip = (item?.sale?.price || 0) - (item?.cost?.price || 0) - (item?.totalDiscount || 0);
         const profitBaht = (item?.sale?.priceBaht || 0) - (item?.cost?.priceBaht || 0);
         const profitUsd = (item?.sale?.priceUsd || 0) - (item?.cost?.priceUsd || 0);
         const saleKip = (item?.sale?.price || 0) - (item?.totalDiscount || 0);

         return [
           covertTimeZone(item?.date),
           saleKip, item?.cost?.price || 0, profitKip,
           item?.sale?.priceBaht || 0, item?.cost?.priceBaht || 0, profitBaht,
           item?.sale?.priceUsd || 0, item?.cost?.priceUsd || 0, profitUsd
         ];
      });

      const data = [headerRow1, headerRow2, ...body];

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet(data);

      // Merge cells
      worksheet['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // Date (Row 0-1, Col 0)
        { s: { r: 0, c: 1 }, e: { r: 0, c: 3 } }, // LAK (Row 0, Col 1-3)
        { s: { r: 0, c: 4 }, e: { r: 0, c: 6 } }, // THB (Row 0, Col 4-6)
        { s: { r: 0, c: 7 }, e: { r: 0, c: 9 } }  // USD (Row 0, Col 7-9)
      ];

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(dataBlob, `report_income_cost_${moment().format('YYYYMMDD')}.xlsx`);
    } catch (error) {
      console.error("Export Error:", error);
      alert("ເກີດຂໍ້ຜິດພາດໃນການ Export (Export Error): " + error.message);
    }
  };

  return (
    <NavDashboard title="ຕົ້ນທຶນ">
      <div style={{ padding: "20px 0", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h5>
          {/* "ກຳລັງພັດທະນາ ຈະເປີດນຳໃຊ້ໃນໄວໆນີ້" */}
          <b>ລາຍງານ ຍອດຕົ້ນທືນ, ຍອດຂາຍ ແລະ ກຳໄລ ຕາມແຕ່ລະມື້, ແຕ່ລະເດືອນ, ປີ</b>
        </h5>
        <div style={{ display: 'flex', gap: '10px' }}>
          <Button
            variant="outline-success"
            onClick={handleDownloadExcel}
            style={{
              borderColor: APP_COLOR,
              color: APP_COLOR,
              backgroundColor: 'transparent',
              fontWeight: 'bold',
              whiteSpace: 'nowrap'
            }}
          >
            Export Excel
          </Button>
          <Button
            variant="outline-secondary"
            onClick={() => setIsCurrentModals(true)}
            style={{ maxWidth: 340 }}
          >
            {!cdFillter.createdAt_gte || !cdFillter.createdAt_lt ? (
              "mm/dd/yyyy"
            ) : (
              <>
                {covertTimeZone(cdFillter.createdAt_gte) +
                  "-" +
                  covertTimeZone(cdFillter.createdAt_lt)}
              </>
            )}
          </Button>
        </div>
      </div>
      {loadingReport && !dataReportIncome ? (
        <AnimationLoading />
      ) : (
        <Row>
          <Col md={4} className="mb-4">
            <Card border="secondary">
              <Card.Header
                style={{
                  minHeight: "40vh",
                  background: LINEAR_GRADIENT_BG,
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: 35,
                  display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'
                }}
              >
                ຕົ້ນທຶນ
                <MdAttachMoney style={{ fontSize: "3em", opacity: 0.2 }} />

              </Card.Header>
              <Card.Body>
                <Card.Text style={{ display: "flex", justifyContent: "space-between", fontWeight: 'bold', fontSize: 18 }}>
                  <p>ເງິນກີບ</p>
                  <p style={{ color: reportDatas?.totalCost?.price < 1 ? "red" : "#000" }}>
                    {numberFormat(reportDatas?.totalCost?.price ?? 0)} ₭
                  </p>
                </Card.Text>
                <Card.Text style={{ display: "flex", justifyContent: "space-between", fontWeight: 'bold', fontSize: 18 }}>
                  <p>ເງິນບາດ</p>
                  <p style={{ color: reportDatas?.totalCost?.priceBaht < 1 ? "red" : "#000" }}>
                    {numberFormat(reportDatas?.totalCost?.priceBaht ?? 0)} ฿
                  </p>
                </Card.Text>
                <Card.Text style={{ display: "flex", justifyContent: "space-between", fontWeight: 'bold', fontSize: 18 }}>
                  <p>ເງິນໂດລາ</p>
                  <p style={{ color: reportDatas?.totalCost?.priceUsd < 1 ? "red" : "#000" }}>
                    {numberFormat(reportDatas?.totalCost?.priceUsd ?? 0)} $
                  </p>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card border="secondary">
              <Card.Header
                style={{
                  minHeight: "40vh",
                  background: LINEAR_GRADIENT_BG,
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: 35,
                  display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'
                }}
              >
                ຍອດຂາຍ
                <MdAttachMoney style={{ fontSize: "3em", opacity: 0.2 }} />


              </Card.Header>
              <Card.Body>
                <Card.Text style={{ display: "flex", justifyContent: "space-between", fontWeight: 'bold', fontSize: 18 }}>
                  <p>ເງິນກີບ</p>
                  <p style={{ color: reportDatas?.totalSale?.price < 1 ? "red" : "#000" }}>
                    {numberFormat((reportDatas?.totalSale?.price ?? 0) - reportDatas?.totalDiscount)} ₭
                  </p>
                </Card.Text>
                <Card.Text style={{ display: "flex", justifyContent: "space-between", fontWeight: 'bold', fontSize: 18 }}>
                  <p>ເງິນບາດ</p>
                  <p style={{ color: reportDatas?.totalSale?.priceBaht < 1 ? "red" : "#000" }}>
                    {numberFormat(reportDatas?.totalSale?.priceBaht ?? 0)} ฿
                  </p>
                </Card.Text>
                <Card.Text style={{ display: "flex", justifyContent: "space-between", fontWeight: 'bold', fontSize: 18 }}>
                  <p>ເງິນໂດລາ</p>
                  <p style={{ color: reportDatas?.totalSale?.priceUsd < 1 ? "red" : "#000" }}>
                    {numberFormat(reportDatas?.totalSale?.priceUsd ?? 0)} $
                  </p>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card border="secondary">
              <Card.Header
                style={{
                  minHeight: "40vh",
                  background: LINEAR_GRADIENT_BG,
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: 35,
                  display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'
                }}
              >
                ເງິນກຳໄລ
                <MdAttachMoney style={{ fontSize: "3em", opacity: 0.2 }} />

              </Card.Header>
              <Card.Body>
                <Card.Text style={{ display: "flex", justifyContent: "space-between", fontWeight: 'bold', fontSize: 18 }}>
                  <p>ເງິນກີບ</p>
                  <p style={{ color: (reportDatas?.totalSale?.price - reportDatas?.totalCost?.price) < 1 ? "red" : "#000" }}>
                    {numberFormat(
                      calculatorProfit(
                        reportDatas?.totalSale?.price || 0, 
                        parseInt(reportDatas?.totalCost?.price || 0) + parseInt(reportDatas?.totalDiscount || 0)
                      ) ?? 0)} ₭
                  </p>
                </Card.Text>
                <Card.Text style={{ display: "flex", justifyContent: "space-between", fontWeight: 'bold', fontSize: 18 }}>
                  <p>ເງິນບາດ</p>
                  <p style={{ color: (reportDatas?.totalSale?.priceBaht - reportDatas?.totalCost?.priceBaht) < 1 ? "red" : "#000" }}>
                    {numberFormat(calculatorProfit(reportDatas?.totalSale?.priceBaht, reportDatas?.totalCost?.priceBaht) ?? 0)} ฿
                  </p>
                </Card.Text>
                <Card.Text style={{ display: "flex", justifyContent: "space-between", fontWeight: 'bold', fontSize: 18 }}>
                  <p>ເງິນໂດລາ</p>
                  <p style={{ color: (reportDatas?.totalSale?.priceUsd - reportDatas?.totalCost?.priceUsd) < 1 ? "red" : "#000" }}>
                    {numberFormat(calculatorProfit(reportDatas?.totalSale?.priceUsd, reportDatas?.totalCost?.priceUsd) ?? 0)} $
                  </p>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {dailyReportDatas.length > 0 && (
        <Card border="secondary" className="mt-4">
          <Card.Header
            style={{
              background: LINEAR_GRADIENT_BG,
              color: "#fff",
              fontWeight: "bold",
              fontSize: 20,
            }}
          >
            ລາຍລະອຽດປະຈຳວັນ
          </Card.Header>
          <Card.Body>
            <Table striped bordered hover responsive>
              <thead>
                <tr style={{ textAlign: "center", verticalAlign: "middle" }}>
                  <th rowSpan="2">ວັນທີ</th>
                  <th colSpan="3">ເງິນກີບ (LAK)</th>
                  <th colSpan="3">ເງິນບາດ (THB)</th>
                  <th colSpan="3">ເງິນໂດລາ (USD)</th>
                </tr>
                <tr style={{ textAlign: "center" }}>
                  <th>ຍອດຂາຍ</th>
                  <th>ຕົ້ນທຶນ</th>
                  <th>ກຳໄລ</th>
                  <th>ຍອດຂາຍ</th>
                  <th>ຕົ້ນທຶນ</th>
                  <th>ກຳໄລ</th>
                  <th>ຍອດຂາຍ</th>
                  <th>ຕົ້ນທຶນ</th>
                  <th>ກຳໄລ</th>
                </tr>
              </thead>
              <tbody>
                {dailyReportDatas.map((item, index) => {
                   const profitKip = (item?.sale?.price || 0) - (item?.cost?.price || 0) - (item?.totalDiscount || 0);
                   const profitBaht = (item?.sale?.priceBaht || 0) - (item?.cost?.priceBaht || 0);
                   const profitUsd = (item?.sale?.priceUsd || 0) - (item?.cost?.priceUsd || 0);

                   const saleKip = (item?.sale?.price || 0) - (item?.totalDiscount || 0);

                   return (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>{covertTimeZone(item?.date)}</td>
                      <td style={{ textAlign: "right" }}>{numberFormat(saleKip)}</td>
                      <td style={{ textAlign: "right" }}>{numberFormat(item?.cost?.price)}</td>
                      <td style={{ textAlign: "right", color: profitKip < 0 ? "red" : "green", fontWeight: "bold" }}>
                        {numberFormat(profitKip)}
                      </td>
                      <td style={{ textAlign: "right" }}>{numberFormat(item?.sale?.priceBaht)}</td>
                      <td style={{ textAlign: "right" }}>{numberFormat(item?.cost?.priceBaht)}</td>
                      <td style={{ textAlign: "right", color: profitBaht < 0 ? "red" : "green", fontWeight: "bold" }}>
                        {numberFormat(profitBaht)}
                      </td>
                      <td style={{ textAlign: "right" }}>{numberFormat(item?.sale?.priceUsd)}</td>
                      <td style={{ textAlign: "right" }}>{numberFormat(item?.cost?.priceUsd)}</td>
                      <td style={{ textAlign: "right", color: profitUsd < 0 ? "red" : "green", fontWeight: "bold" }}>
                        {numberFormat(profitUsd)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      )}

      <CurrentDateComponents
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setCdFillter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
      />
    </NavDashboard>
  );
}
